export default __webpack_public_path__ + "static/media/Stars.fdb3df77.svg";